import { useState } from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";

export const TagChip = ({ tag, active, onClick, onRemove, count, testid }) => (
  <span role={onClick ? "button" : undefined} onClick={onClick} data-testid={testid}
    className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs transition-colors ${onClick ? "cursor-pointer" : ""} ${active ? "border-[#14B8A6] bg-[#14B8A6]/15 text-[#5EEAD4]" : "border-[#2D3442] text-[#A8A090] hover:border-[#14B8A6]/60 hover:text-[#5EEAD4]"}`}>
    #{tag}{count != null && <span className="opacity-60">{count}</span>}
    {onRemove && <button type="button" onClick={(e) => { e.stopPropagation(); onRemove(); }} aria-label={`Remove ${tag}`} data-testid={`${testid}-remove`}><X className="h-3 w-3" /></button>}
  </span>
);

export const TagInput = ({ value, onChange, known = [], testid = "tag-input" }) => {
  const [text, setText] = useState("");
  const add = (t) => {
    const tag = t.trim().toLowerCase().replace(/^#/, "");
    if (tag && !value.includes(tag)) onChange([...value, tag]);
    setText("");
  };
  const sugg = known.map((k) => k.tag).filter((t) => !value.includes(t) && t.includes(text.trim().toLowerCase())).slice(0, 8);
  return (
    <div className="space-y-2" data-testid={testid}>
      {value.length > 0 && <div className="flex flex-wrap gap-1.5">{value.map((t) => <TagChip key={t} tag={t} active onRemove={() => onChange(value.filter((x) => x !== t))} testid={`${testid}-chip-${t}`} />)}</div>}
      <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="Add a tag (e.g. prophecy) and press Enter" className="h-9"
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(text); } }} data-testid={`${testid}-field`} />
      {sugg.length > 0 && (
        <div className="flex flex-wrap gap-1.5">{sugg.map((t) => <TagChip key={t} tag={t} onClick={() => add(t)} testid={`${testid}-suggest-${t}`} />)}</div>
      )}
    </div>
  );
};
